import I24NewsPlusIcon from '../../../../../../legacy_components/Icons/Menu/I24NewsPlusIcon'
import Link from '../../../../../Routing/Link'
import PropTypes from 'prop-types'
import React from 'react'
import { getLocales } from '../../../../../../utilities/locales'
import translate from '../../../../../../utilities/translate'
import translations from './translations'

const trans = translate(translations)

// I24NewsPlusLink :: Props -> React.Component
const I24NewsPlusLink = ({ locale }) =>
  <Link href={ trans(locale)('link') } aria-label={ trans(locale)('label') }>
    <I24NewsPlusIcon width={ 40 } />
  </Link>

I24NewsPlusLink.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
}

export default I24NewsPlusLink
